import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Button from './common/Button';
import { getCancelDialogConfig } from '../common/Util';
import { setCloseDialog, setIsDataModified } from '../features/common/commonSlice';

const DetailButtonSection = ({ onSave, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation('common');
  const { isDataModified, closeDialog } = useSelector(state => state.common);

  useEffect(() => {
    //예, 취소하겠습니다 클릭했을때 이벤트
    if (closeDialog) {
      dispatch(setIsDataModified(false));
      dispatch(setCloseDialog(false));
      if (onClose) {
        onClose();
      } else {
        navigate(-1);
      }
    }
  }, [closeDialog]);

  const handleCancel = async () => {
    if (isDataModified) {
      //입력된 내용이 저장되지 않았~ 취소하시겠~~?
      dispatch(getCancelDialogConfig(tCommon, 'notSaved'));
    } else {
      if (onClose) {
        onClose();
      } else {
        navigate(-1);
      }
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave();
    }
    if (isDataModified) {
      dispatch(setIsDataModified(false));
    }
  };

  return (
    <div className="displayFlex" style={{ gap: '8px' }}>
      <Button value={tCommon('cancel')} color="secondary" onClick={handleCancel} />
      <Button value={tCommon('save')} style={{ flex: 1 }} onClick={handleSave} />
    </div>
  );
};

export default DetailButtonSection;
